export default __webpack_public_path__ + "static/media/admin_goals_black.d590f486.svg";